import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"icon-minus\"><path fill-rule=\"evenodd\" d=\"M.837 7.726h14.326c.113 0 .17.054.17.163V9.11c0 .109-.057.163-.17.163H.837c-.114 0-.17-.054-.17-.163V7.89c0-.109.056-.163.17-.163z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol